import { TextField, useFormField } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import { IconButton } from '@calendly/ui/components/icon-button';
import { DeleteIcon } from '@calendly/ui/components/icons';
import classNames from 'classnames';
import { nanoid } from 'nanoid';
import { useEffect, forwardRef } from 'react';
import ErrorMessage from 'components/core/error_message';
import { useAdvancedSortable, VerticalSortableContext } from 'components/core/sortable';
import { AddButton } from '../../../components';
import { useErrorAfterInitialTouch } from '../../hooks';
import { StyledDragIcon } from '../styles';
const answerChoiceContainerIsDraggingCss = "aft5jof";
const answerChoiceContainerCss = "acopzkf";
const AnswerChoiceContainer = forwardRef((props, ref) => {
  const {
    isDragging,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(answerChoiceContainerCss, {
    [answerChoiceContainerIsDraggingCss]: isDragging
  }, props.className)} />;
});
const styledTextFieldCss = "s1vjgdln";
const StyledTextField = forwardRef((props, ref) => <TextField ref={ref} {...props} className={classNames(styledTextFieldCss, props.className)} />);
const getBlankAnswerChoice = () => ({
  id: nanoid(5),
  choice: ''
});
const MAX_ANSWERS_COUNT = {
  select: 300,
  choices_one: 200,
  choices_many: 200
};
const generateAnswerChoices = () => [...Array(3).keys()].map(() => getBlankAnswerChoice());
const AnswerChoice = ({
  id,
  fieldName,
  deleteChoice,
  canDelete
}) => {
  useErrorAfterInitialTouch(fieldName);
  const {
    sortable: {
      isDragging,
      attributes,
      listeners,
      setNodeRef
    },
    itemStyle
  } = useAdvancedSortable({
    id
  });
  return <AnswerChoiceContainer ref={setNodeRef} isDragging={isDragging} {...itemStyle}>
      <StyledDragIcon {...attributes} {...listeners} />
      <StyledTextField name={fieldName} />
      {canDelete && <IconButton aria-label={I18n.t('publisher.action.delete')} onClick={() => deleteChoice(id)} size="small" title={I18n.t('publisher.action.delete')}>
          <DeleteIcon />
        </IconButton>}
    </AnswerChoiceContainer>;
};
export const AnswerChoiceSection = ({
  index
}) => {
  const [{
    value: format
  }] = useFormField({
    name: `inviteeQuestions.${index}.format`
  });
  const [{
    value: answerChoices
  }, {
    error: answerChoicesError
  }, {
    setValue
  }] = useFormField({
    name: `inviteeQuestions.${index}.answerChoices`
  });
  const deleteChoice = toDelete => {
    setValue(answerChoices.filter(({
      id
    }) => id !== toDelete));
  };
  const addNewChoice = () => {
    setValue([...answerChoices, getBlankAnswerChoice()]);
  };
  useEffect(() => {
    if (!answerChoices) {
      setValue(generateAnswerChoices());
    }
  }, [answerChoices, setValue]);
  if (!answerChoices) return null;
  const handleReorderAnswers = newOrder => {
    setValue(newOrder);
  };
  const canAddNew = answerChoices.length < MAX_ANSWERS_COUNT[format];
  const shouldDisplayError = typeof answerChoicesError === 'string' || answerChoicesError instanceof String;
  return <>
      <VerticalSortableContext items={answerChoices} setItems={handleReorderAnswers}>
        {answerChoices.map(({
        id
      }, idx) => <AnswerChoice key={id} id={id} fieldName={`inviteeQuestions.${index}.answerChoices.${idx}.choice`} deleteChoice={deleteChoice} canDelete={answerChoices.length > 1} />)}
      </VerticalSortableContext>
      {shouldDisplayError && <ErrorMessage message={answerChoicesError} />}
      <AddButton onClick={addNewChoice} disabled={!canAddNew}>
        {I18n.t('publisher.event_type_editor.sections.more_options.invitee_form.add_another')}
      </AddButton>
    </>;
};

require("./answer_choice_section.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./answer_choice_section.js");